import {Pipe, PipeTransform} from '@angular/core';
import {GlobalNotification} from '../../../@backend/modules/@users/models/global-notification.model';

@Pipe({
  name: 'notificationIcon'
})
export class NotificationIconPipe implements PipeTransform {

  transform(value: GlobalNotification): string {
    if (value.notificationType === 'INFO') {
      return 'info';
    } else if (value.notificationType === 'WARNING') {
      return 'report_problem';
    } else if (value.notificationType === 'ERROR') {
      return 'error_outline';
    } else if (value.notificationType === 'SUCCESS') {
      return 'announcement';
    }
  }
}
